import React, { useContext, useState } from "react";
import { Formik, Form, Field, ErrorMessage, useFormik } from "formik";
import * as Yup from "yup";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { login } from "../../../authContext/apiCalls";
import { AuthContext } from "../../../authContext/AuthContext";
import { BeatLoader 
} from "react-spinners";
import { useEffect } from "react";
const validationSchema = Yup.object({
  email: Yup.string().email("Invalid email address").required("Required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Required"),
});

const LoginPopup = ({Loginpop,SetLoginPop,Registerpop,SetRegisterpop}) => {
  const [showPassword, setShowPassword] = useState(false);
  const { dispatch, user } = useContext(AuthContext);
  const navigate = useNavigate();

  
  useEffect(() => {
    if(user){
      SetLoginPop(!Loginpop)
    }
  }, [user])
  

  return (
    <div className="fixed top-0 left-0 z-[3000] w-screen h-screen backdrop-blur-sm  bg-black bg-opacity-50  font-jt">
      <div className="flex relative flex-col lg:flex-row bg-white h-full lg:h-fit lg:my-10 w-[100%] lg:w-[84%] lg:rounded-2xl mx-auto py-8 shadow-lg">
        <button
        onClick={()=>{SetLoginPop(!Loginpop)}}
        className="absolute top-4 right-4 transition-all hover:scale-[1.05] text-gray-600 hover:text-gray-800">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.0001 0.416656C12.918 0.416656 9.90512 1.3306 7.34245 3.04292C4.77979 4.75524 2.78243 7.18902 1.60297 10.0365C0.4235 12.884 0.114898 16.0173 0.716184 19.0401C1.31747 22.063 2.80164 24.8397 4.98101 27.0191C7.16038 29.1984 9.93706 30.6826 12.9599 31.2839C15.9828 31.8852 19.1161 31.5766 21.9636 30.3971C24.8111 29.2176 27.2448 27.2203 28.9572 24.6576C30.6695 22.095 31.5834 19.0821 31.5834 16C31.5834 11.867 29.9416 7.90335 27.0192 4.98091C24.0967 2.05847 20.133 0.416656 16.0001 0.416656ZM22.6683 20.6651C22.8036 20.7958 22.9116 20.9521 22.9858 21.1249C23.0601 21.2978 23.0991 21.4837 23.1008 21.6718C23.1024 21.8599 23.0666 22.0464 22.9953 22.2205C22.9241 22.3946 22.8189 22.5528 22.6859 22.6858C22.5529 22.8188 22.3947 22.924 22.2206 22.9952C22.0465 23.0665 21.86 23.1023 21.6719 23.1007C21.4837 23.099 21.2979 23.06 21.125 22.9857C20.9522 22.9115 20.7959 22.8035 20.6652 22.6682L16.0001 18.0032L11.335 22.6682C11.2043 22.8035 11.048 22.9115 10.8752 22.9857C10.7023 23.06 10.5164 23.099 10.3283 23.1007C10.1402 23.1023 9.95367 23.0665 9.77957 22.9952C9.60547 22.924 9.44729 22.8188 9.31428 22.6858C9.18126 22.5528 9.07607 22.3946 9.00484 22.2205C8.93361 22.0464 8.89777 21.8599 8.8994 21.6718C8.90103 21.4837 8.94011 21.2978 9.01436 21.1249C9.08861 20.9521 9.19653 20.7958 9.33184 20.6651L13.9969 16L9.33184 11.3349C9.19653 11.2042 9.08861 11.0479 9.01436 10.8751C8.94011 10.7022 8.90103 10.5163 8.8994 10.3282C8.89777 10.1401 8.93361 9.95357 9.00484 9.77947C9.07607 9.60537 9.18126 9.44719 9.31428 9.31418C9.44729 9.18116 9.60547 9.07597 9.77957 9.00474C9.95367 8.93351 10.1402 8.89767 10.3283 8.8993C10.5164 8.90094 10.7023 8.94002 10.8752 9.01426C11.048 9.08851 11.2043 9.19643 11.335 9.33174L16.0001 13.9968L20.6652 9.33174C20.7959 9.19643 20.9522 9.08851 21.125 9.01426C21.2979 8.94002 21.4837 8.90094 21.6719 8.8993C21.86 8.89767 22.0465 8.93351 22.2206 9.00474C22.3947 9.07597 22.5529 9.18116 22.6859 9.31418C22.8189 9.44719 22.9241 9.60537 22.9953 9.77947C23.0666 9.95357 23.1024 10.1401 23.1008 10.3282C23.0991 10.5163 23.0601 10.7022 22.9858 10.8751C22.9116 11.0479 22.8036 11.2042 22.6683 11.3349L18.0033 16L22.6683 20.6651Z"
              fill="#D00808"
            />
          </svg>
        </button>
        <img
          src="/Untitled.png"
          alt=""
          className="lg:block hidden mx-auto  h-[600px] w-[600px]"
        />
        <div className="font-jt bg-white p-4 lg:p-8 rounded-lg w-full lg:w-1/2">
          <h2 className="text-2xl font-extrabold mb-3 text-[45px]">Login</h2>
          <p className="text-[#241E1E] font-thin mt-6 mb-16 text-[25px]">
            Use your email address to sign in
          </p>
          <Formik
          initialValues={{ email: "", password: "" }}
          validationSchema={validationSchema}
          onSubmit={async (values, { setSubmitting, setFieldError }) => {
            try {
              setSubmitting(true);
              await login(values, dispatch);
              if (user) {
                SetLoginPop(!Loginpop)
                
              }
            } catch (error) {
              console.error(error,"234aa"); // Log or handle your error here
              setFieldError("password", "Wrong Email/Password"); // display server error message
            } finally {
              setSubmitting(false);
            }
          }}
        >
            {({ isSubmitting }) => (
              <Form className="space-y-4" >
                <div className="relative">
                  <label
                    htmlFor="email"
                    className="font-semibold text-[16px] absolute z-10 left-[35px] -top-[10px] bg-white"
                  >
                    Email
                  </label>
                  <Field
                    id="email"
                    name="email"
                    type="email"
                    className="relative mb-4 border-[3px] block text-[18px] py-3 px-5 text-black bg-transparent border-black rounded-full w-full"
                  />
                  <ErrorMessage
                    name="email"
                    className="text-red-600 text-[16px] ml-5 "
                    component="div"
                  />
                </div>
                <div className="relative">
                  <label
                    htmlFor="password"
                    className="font-semibold text-[16px] absolute z-10 left-[35px] -top-[10px] bg-white"
                  >
                    Password
                  </label>
                  <Field
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    className="relative mb-4 border-[3px] block text-[18px] py-3 px-5 text-black bg-transparent border-black rounded-full w-full"
                  />
                  <button
                  type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-4 top-7 transform -translate-y-1/2"
                  >
                    {!showPassword ? (
                      <i class="fa fa-eye-slash" aria-hidden="true"></i>
                    ) : (
                      <i class="fa fa-eye" aria-hidden="true"></i>
                    )}
                  </button>
                  <ErrorMessage
                    name="password"
                    className="text-red-600 text-[16px] ml-5 "
                    component="div"
                  />
                  
                </div>

                <div className="flex flex-row justify-between mb-12">
                  <div className="flex items-center mt-4 ">
                    <input
                      type="checkbox"
                      id="rememberMe"
                      className="mr-2 w-4 h-4 rounded-md focus:ring-black"
                    />
                    <label htmlFor="rememberMe" className="text-gray-600">
                      Remember me
                    </label>
                  </div>
                  <a className="mt-4 underline font-medium " href="#">
                    Forgot Password?
                  </a>
                </div>

                <button
                  type="submit"
                  className="bg-black text-white w-full py-2 rounded-full mb-6 shadow-md"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (<BeatLoader  color={"white"} size={14} />) : "Login"}
                </button>
              </Form>
            )}
          </Formik>
          <p className="text-sm text-center text-gray-600">
            By clicking on Login, you agree to our{" "}
            <Link to="/TermsAndCondition" className="underline">
              Terms & Conditions
            </Link>{" "}
            and{" "}
            <Link to="/privacy" className="underline">
              Privacy Policy
              </Link>
          </p>
          <div className="text-center mt-4">
            <span className="text-gray-600">Not a member yet?</span>{" "}
            <button onClick={()=>{SetRegisterpop(!Registerpop);SetLoginPop(!Loginpop)}} className="text-indigo-500 underline">
              Register
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPopup;
